import State from '@/classes/state';
import FilterGroupFilterCombi from '@/classes/filter-group-filter-combi.model';
import FilterGroup from '@/models/filter-group.model';
import Filter from '@/models/filter.model';
import PredefinedFilterItem from '@/models/predefined-filter-item.model';

const mutationUtils = {
    /**
     * Selects the product filter
     * of the given filterGroupFilterCombi
     * @param state - The Vuex state
     * @param filterGroupFilterCombi - The filterGroup-filter combination
     */
    selectProductFilter: (state: State, filterGroupFilterCombi: FilterGroupFilterCombi) => {
        const index = state.selectedFilters.findIndex(selectedFilter => selectedFilter.filter.id === filterGroupFilterCombi.filter.id);

        if (index !== -1) {
            return;
        }

        state.selectedFilters.push(filterGroupFilterCombi);
    },
    /**
     * Unselects all of the given product filters
     * @param state - The Vuex state
     * @param filters - An array of Filters to unselect
     */
    unselectProductFilters: (state: State, filters: Array<Filter>) => {
        filters.forEach(filter => {
            const index = state.selectedFilters.findIndex(selectedFilter => selectedFilter.filter.id === filter.id);
    
            if (index === -1) {
                return;
            }
    
            state.selectedFilters.splice(index, 1);
        });
    },
};

const mutations = {
    /**
     * Sets the product sorting
     * @param state - The Vuex state
     * @param productSorting - The sorting string
     */
    SET_PRODUCT_SORTING(state: State, productSorting: string) {
        state.productSorting = productSorting;
    },
    /**
     * Selects the filter of the given
     * filterGroupFilterCombi
     * @param state - The Vuex state
     * @param filterGroupFilterCombi- The filterGroup-filter combination
     */
    SELECT_PRODUCT_FILTER(state: State, filterGroupFilterCombi: FilterGroupFilterCombi) {
        mutationUtils.selectProductFilter(state, filterGroupFilterCombi);
    },
    /**
     * Unselects the filter of the given
     * filterGroupFilterCombi
     * @param state - The Vuex state
     * @param filterGroupFilterCombi- The filterGroup-filter combination
     */
    UNSELECT_PRODUCT_FILTER(state: State, filterGroupFilterCombi: FilterGroupFilterCombi) {
        mutationUtils.unselectProductFilters(state, [filterGroupFilterCombi.filter]);
    },
    /**
     * Unselects all filters of the given
     * filterGroup
     * @param state - The Vuex state
     * @param filterGroup- The filterGroup
     */
    UNSELECT_PRODUCT_FILTER_GROUP(state: State, filterGroup: FilterGroup) {
        mutationUtils.unselectProductFilters(state, filterGroup.filters);
    },
    /**
     * Resets all selected product filters
     * @param state - The Vuex state
     */
    RESET_PRODUCT_FILTERS(state: State) {
        state.selectedFilters = [];
    },
    UNSELECT_PREDEFINED_FILTER_ITEM(state: State, predefinedFilterItem: PredefinedFilterItem) {
        const index = state.predefinedFilterItems.indexOf(predefinedFilterItem);
    
        if (index === -1) {
            return;
        }

        state.predefinedFilterItems.splice(index, 1);
    },
    /**
     * Show more products
     * by incrementing the productLimit
     * @param state - The Vuex state
     */
    SHOW_MORE_PRODUCTS(state: State) {
        state.productLimit += state.config.chunkSize;
    },
    /**
     * Show all products
     * @param state - The Vuex state
     */
     SHOW_ALL_PRODUCTS(state: State) {
        state.productLimit = state.products.length;
    },
    /**
     * Show initial products by
     * setting the productLimit to
     * the initial chunkSize
     * @param state - The Vuex state 
     */
    SHOW_INITIAL_PRODUCTS(state: State) {
        state.productLimit = state.config.initialChunkSize;
    },
    /**
     * Saves the state of the
     * app using the stateMemoryManager
     * @param state - The Vuex state 
     */
    SAVE_STATE: (state: State) => {
        state.save();
    },
};

export default mutations;
